module.exports = __webpack_public_path__ + "static/media/om_eyeshape_downturned_grey.184bc86a.png";